import "./BottomAdvertisement.scss";
import images from "../../assets/images";
import { FC } from "react";
import { SCHOOL_ADMIN } from "../../utils/constants";
import { useAppSelector } from "../../redux/app/hooks";

interface PropsType {
  adImage: string;
  handlecloseAd? : () => void
  showcloseIcon ? : boolean
}
const BottomAdvertisement: FC<PropsType> = ({ adImage, handlecloseAd, showcloseIcon }) => {
  const {closeIconround} = images
  const role = useAppSelector((state) => state.auth.role);
  
  return (
    <div className="bottomAdContainer" style={{ display : role === SCHOOL_ADMIN ? "none": "" }}>
      {adImage && (
        <>
          {" "}
          <img src={adImage} alt="adImage" className="bottomAdStyle" />
          {showcloseIcon && <img className="close-ad-button" onClick={handlecloseAd} alt="close" src={closeIconround}/>}
        </>
      )}
    </div>
  );
};

export default BottomAdvertisement;
